import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getDateValidationError } from "../../../../utils";
import styles from "./DateSelector.module.css";

const DateSelector = ({ selectedDate, onDateChange }) => {
  const [validationError, setValidationError] = useState("");

  const handleDateChange = (field, value) => {
    onDateChange(field, value);
  };

  // Validate immediately when any date part changes
  useEffect(() => {
    const error = getDateValidationError(
      selectedDate.day,
      selectedDate.month,
      selectedDate.year,
    );
    setValidationError(error || "");
  }, [selectedDate.day, selectedDate.month, selectedDate.year]);

  return (
    <div className={styles.container}>
      <h3 id="date-selector-heading" className={styles.title}>
        When would you like your new energy contract to start?
      </h3>
      <p className={styles.subtitle}>
        Please ensure that you're free to leave your current supplier on the
        date you choose and if applicable, you've served notice of termination.
        <br /> <br />
        For us to set up your energy supply, please select a date at least 21
        calendar days from today's date which is the earliest potential start
        date{" "}
      </p>
      <div className={styles.dateSelectors}>
        {/* Day Selector */}
        <select
          id="date-day"
          value={selectedDate.day}
          onChange={(e) => handleDateChange("day", e.target.value)}
          className={`${styles.dateSelect} ${validationError ? styles.inputError : ""}`}
          required
          aria-invalid={!!validationError}
          aria-describedby={validationError ? "date-error" : undefined}
        >
          {Array.from({ length: 31 }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>

        {/* Month Selector */}
        <select
          id="date-month"
          value={selectedDate.month}
          onChange={(e) => handleDateChange("month", e.target.value)}
          className={`${styles.dateSelect} ${validationError ? styles.inputError : ""}`}
          required
          aria-invalid={!!validationError}
          aria-describedby={validationError ? "date-error" : undefined}
        >
          <option value="Jan">Jan</option>
          <option value="Feb">Feb</option>
          <option value="Mar">Mar</option>
          <option value="Apr">Apr</option>
          <option value="May">May</option>
          <option value="Jun">Jun</option>
          <option value="Jul">Jul</option>
          <option value="Aug">Aug</option>
          <option value="Sep">Sep</option>
          <option value="Oct">Oct</option>
          <option value="Nov">Nov</option>
          <option value="Dec">Dec</option>
        </select>

        {/* Year Selector */}
        <select
          id="date-year"
          value={selectedDate.year}
          onChange={(e) => handleDateChange("year", e.target.value)}
          className={`${styles.dateSelect} ${validationError ? styles.inputError : ""}`}
          required
          aria-invalid={!!validationError}
          aria-describedby={validationError ? "date-error" : undefined}
        >
          {Array.from({ length: 10 }, (_, i) => (
            <option key={2020 + i} value={2020 + i}>
              {2020 + i}
            </option>
          ))}
        </select>
      </div>

      {/* Error Message - positioned exactly like in the reference */}
      {validationError && (
        <div
          id="date-error"
          className={styles.errorMessage}
          role="alert"
          aria-live="polite"
        >
          {validationError}
        </div>
      )}
    </div>
  );
};

DateSelector.propTypes = {
  selectedDate: PropTypes.shape({
    day: PropTypes.string.isRequired,
    month: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
  }).isRequired,
  onDateChange: PropTypes.func.isRequired,
};

export default DateSelector;
